import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { shallowEqual, useSelector } from 'react-redux';
import TuneIcon from '@mui/icons-material/Tune';
import Badge from '@mui/material/Badge';
import { DATE_RAGE_START, DATE_RANGE_END } from '#component/general/list-filter/constants';
import { isFilterExist } from '#component/general/list-filter/helper';
import {
  FilterButton as StyledFilterButton,
  BadgeContainer,
  BadgeContainerActive,
  BadgeIcon,
  FilterButtonLabel
} from '#component/general/list-filter/components/general/styles';

export const FilterButton = ({
  open,
  label,
  relatedTo,
  setModalOpen
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const filter = useSelector(s => s.listFilter?.[relatedTo], shallowEqual);
  const filterExist = isFilterExist(filter, [DATE_RAGE_START, DATE_RANGE_END]);

  const handleFilterModal = () => {
    setModalOpen(!open);
  };

  const BadgeWrapper = open ? BadgeContainerActive : BadgeContainer;

  return (
    <StyledFilterButton
      aria-label="menu"
      onClick={handleFilterModal}
      id="list-search-parent"
    >
      <BadgeWrapper>
        <Badge
          id="list-search-badge"
          color="secondary"
          variant="dot"
          invisible={!filterExist || open}
        >
          <BadgeIcon>
            <TuneIcon id="list-search-filter-icon" />
          </BadgeIcon>
        </Badge>
      </BadgeWrapper>
      {!isMobile && <FilterButtonLabel>{label}</FilterButtonLabel>}
    </StyledFilterButton>
  );
};
